import { render } from "./editTask.vue?vue&type=template&id=09c38a60&scoped=true"
import script from "./editTask.vue?vue&type=script&lang=js"
export * from "./editTask.vue?vue&type=script&lang=js"

import "./editTask.vue?vue&type=style&index=0&id=09c38a60&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c38a60"]])

export default __exports__